import locale from "@bonliva-crm/locale";
import { QualityCheck, QualityCheckProps } from "..";
import { useRequestSent } from "../use-request-sent";
import { QualityCheckButton } from "../quality-check-button";
import { HSAIDExtraLabels } from "./hsaid-extra-labels";
import { HsaidLabel } from "./hsaid-label";

export function HsaidQualityCheck(props: QualityCheckProps) {
  const { data, consultantData } = props;

  if (data.Name !== "HSAID/SITHS") {
    throw new Error("HsaidQualityCheck can only be used for HSAID/SITHS");
  }

  const { onRequestSent, loading } = useRequestSent({
    data,
    consultantData
  });

  return (
    <QualityCheck
      renderLabel={(label) => <HsaidLabel label={label} />}
      renderExtraAction={() => (
        <QualityCheckButton
          text={locale.Order}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRequestSent();
          }}
          disabled={loading}
          loading={loading}
        />
      )}
      // Moved to extra labels so we can show paused until date / expires date
      showExpiresOn={false}
      renderExtraLabels={() => <HSAIDExtraLabels data={data} />}
      {...props}
    />
  );
}
